import React from 'react'
import './style.scss'
//import NaviContext from '../../../context/NaviContext'

function Logo(props) {
	//const naviContext = useContext(NaviContext)

  return (
		<div id="master-logo" className='logo'>
			<div className="aspect-ratio"></div>
		</div>
  )
}

export default Logo